const BASE_URL = 'https://acko-cms.ackoassets.com/'

export const RIGHT_ARROW_URL = `${BASE_URL}arrow_right_17fdfcd600.svg`
export const RIGHT_ARROW_BLUE_URL = `${BASE_URL}arrow_right_ac5f6c0dd4.svg`
export const RIGHT_CHEVRON_URL = `${BASE_URL}chevron_right_c1e7ad2149.svg`
export const PHONE_CALL_URL = `${BASE_URL}Phone_8a5a405dd3.svg`
